import { render, staticRenderFns } from "./SlotTypeForm.vue?vue&type=template&id=13064898&"
import script from "./SlotTypeForm.vue?vue&type=script&lang=js&"
export * from "./SlotTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports